<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-office-building</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Registro total de instituciones</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ items.length }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-account-clock</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Pendientes de verificación</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ pendings.length }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                    <v-card-actions>
                        <v-btn text block @click="validations_dialog = !validations_dialog" :disabled="!pendings.length > 0">
                            <strong>validar</strong>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" lg="9" style="position:relative; top: -60px">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :footer-props="footer_props"
                        :loading-text="loading_text"
                        :no-data-text="no_data_text"
                        :no-results-text="no_result_text"
                        :search="search"
                    >
                        <template v-slot:top>
                            <v-container class="py-0">
                                <v-row justify="center" align="center">
                                    <v-col cols="12" lg="6">

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" @click="create_dialog = !create_dialog" dark>
                                                    <v-icon>mdi-plus-circle</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Nuevo registro</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" dark>
                                                    <v-icon>mdi-file-pdf</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Exportar</span>
                                        </v-tooltip>

                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            label="Buscar"
                                            append-icon="mdi-magnify"
                                            color="#818181"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="() => { item_dialog = item; show_dialog = !show_dialog }">Mostrar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="edit(item)">Editar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text>Referidos</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text>Eliminar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <create :dialog="create_dialog" :post_url="post_url"></create>
        <validations :pendings="pendings" :dialog="validations_dialog" :refuse_url="refuse_url" :accept_url="accept_url"></validations>
        <edit :dialog="edit_dialog" :item="item_dialog" :update_url="update_url"></edit>
        <show :dialog="show_dialog" :item="item_dialog"></show>

    </v-container>
</template>
<script>

import validations from './validations'
import create from './create'
import edit from './edit'
import show from './show'

export default {
    components:{
        validations,
        create,
        show,
        edit
    },
    data: () => ({
        //urls
        get_data :"/institutes",
        post_url :"/institutes/store",
        refuse_url:"/institutes/pendings/refuse",
        accept_url:"/institutes/pendings/accept",
        update_url:"/institutes/update",

        //dialogs
        create_dialog: false,
        show_dialog:false,
        edit_dialog:false,
        validations_dialog: false,

        //item dialog
        item_dialog:"",

        //props
        items:[],
        pendings:[],

        //data table props
        color:"#818181",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID', value:'id' },
            { text:'Código', value:'code' },
            { text:'Nombre', value:'name' },
            { text:'Fecha de registro', value:'registration_date'},
            { text:'Descuento', value:'discount' },
            { text:'Pago por estudiante', value:'per_person' },
            { text: 'Acciones', value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        }
    }),

    mounted(){
        this.getItems()
    },

    methods:{
        getItems: function(){
            axios.get(this.get_data).then(response => {
                this.items = response.data.institutes
                this.pendings = response.data.pendings

                this.loading = false
            }).catch(error => {})
        },

        item:function(item){
            return Object.assign({}, this.items[this.items.indexOf(item)])
        },

        edit:function(item){
            this.item_dialog = this.item(item)
            this.edit_dialog = true
        }
    }
}
</script>
